import { Button, Icon } from 'antd';
import { createPortal } from 'react-dom';

import { FormFooter } from 'components/forms/FormFooter';
import { useI18nContext } from 'components/I18nProvider';
import { SKULL_CUSTOM_FOOTER_PORTAL_ROOT_ID, useSkullConfigContext } from 'components/skull';
import { tCommon } from 'utils/i18nUtil';

export interface SDKCustomSynapseFileUploadFooterProps {
  processing?: boolean;
  editing?: boolean;
  hasChanges?: boolean;
  disableNextButton?: boolean;
  onSave: () => void;
}

export const SDKCustomSynapseFileUploadFooter = ({
  processing,
  hasChanges,
  disableNextButton,
  editing,
  onSave,
}: SDKCustomSynapseFileUploadFooterProps) => {
  const { tn } = useI18nContext();
  const { currentStep, next, steps } = useSkullConfigContext();

  const footerRootNode = document.getElementById(SKULL_CUSTOM_FOOTER_PORTAL_ROOT_ID);
  if (!footerRootNode) {
    return null;
  }

  const nextStepName = steps?.[currentStep + 1]?.stepName;
  let buttonText = nextStepName ?? tn('create_custom_synapse');
  let actionButtonAction = onSave;
  let isNextTraversal = true;
  if (editing) {
    if (processing) {
      buttonText = tn('processing_synapse');
      isNextTraversal = false;
    } else if (hasChanges) {
      buttonText = tn('update_draft');
      isNextTraversal = false;
    } else {
      buttonText = nextStepName ?? tCommon('next');
      actionButtonAction = next;
    }
  }

  return createPortal(
    <FormFooter
      right={
        <Button
          type="primary"
          loading={processing}
          disabled={processing || disableNextButton}
          onClick={actionButtonAction}>
          {buttonText}
          {isNextTraversal && (
            <>
              {' '}
              <Icon type="arrow-right" />
            </>
          )}
        </Button>
      }
    />,
    footerRootNode
  );
};
